import React from 'react';
import EventsComponent from '../components/EventsComponents';

function EventsPage() {
  // Categorías de eventos disponibles
  const categorias = ["Charla", "Exposicion", "Networking", "Conferencia", "Ruta", "Carrera/Competición", "Feria/Salón", "Concentración", "Otras"];
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3005';
  
  // Estado para almacenar los eventos
  const [events, setEvents] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  //Recuperamos todos eventos
  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${baseUrl}/events`);
      console.log("Response status:", response.status); // Verifica el estado de la respuesta
      const data = await response.json();
      console.log("Fetched events:", data); // Verifica los datos recibidos
      setEvents(data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
    finally {
      setLoading(false);
    }
  };
  const handleDelete = async (eventId) => {
    try {
      const res = await fetch(`${baseUrl}/events/${eventId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      if (res.ok) {
        setEvents(events.filter(e => e._id !== eventId));
      } else {
        console.error('Error eliminando evento:', res.statusText);
      }
    } catch (err) {
      console.error('Error eliminando evento:', err);
    }
  };

  React.useEffect(() => {
    fetchEvents();
  }, []); // Llamar a fetchEvents una vez al montar el componente

  return (
    <div>
      <EventsComponent events={events} categorias={categorias} mesAnio="Septiembre 2025" currentUserId={localStorage.getItem("userId")} handleDelete={handleDelete} loading={loading} />
    </div>
  );
}

export default EventsPage;
